var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _g4, _path9, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDalocal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_64_328)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_328)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3361 42.2993C23.3361 42.2993 23.371 42.2646 23.4408 42.23C24.8021 41.3972 30.2477 35.7069 31.8185 34.1802C37.7178 28.3857 36.2517 20.5095 31.4694 16.207C31.0156 15.7212 30.4222 15.2702 29.724 14.8885C27.874 13.7435 25.6748 13.0496 23.3011 13.0843C20.9275 13.0496 18.7283 13.7435 16.8782 14.9232C16.215 15.3049 15.5867 15.7559 15.1329 16.2417C10.3506 20.5095 8.91943 28.3857 14.7838 34.1802C16.3546 35.7416 21.8001 41.3972 23.1615 42.23C23.1964 42.2646 23.2313 42.2993 23.2662 42.2993C23.3011 42.2993 23.3011 42.2993 23.3361 42.2993Z",
    fill: "#F48121"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_64_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 13,
    width: 25,
    height: 29
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6852 41.3626C23.6852 41.3626 23.7201 41.3279 23.7551 41.2932C25.0815 40.5298 30.2129 35.1517 31.7139 33.6945C37.2641 28.247 35.9376 20.7871 31.3997 16.7275C30.9808 16.2764 30.3874 15.8601 29.7591 15.4784C28.0137 14.3681 25.9193 13.7435 23.6852 13.7782C21.4163 13.7435 19.3568 14.4028 17.5765 15.4784C16.9482 15.8601 16.3548 16.2764 15.9359 16.7275C11.4329 20.7871 10.0715 28.247 15.6217 33.6945C17.1227 35.1517 22.2541 40.5298 23.5456 41.2932C23.5805 41.3279 23.6154 41.3626 23.6154 41.3626C23.6503 41.3626 23.6503 41.3626 23.6852 41.3626Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_64_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2641 13.7437H10.0715V41.3627H37.2641V13.7437Z",
    fill: "url(#paint1_linear_64_328)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6852 19.9546C26.7222 19.9546 29.2006 22.4181 29.2006 25.4368C29.2006 28.4554 26.7222 30.9189 23.6852 30.9189C20.6483 30.9189 18.1699 28.4554 18.1699 25.4368C18.1699 22.4181 20.6134 19.9546 23.6852 19.9546Z",
    fill: "#F48121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6851 20.7524C26.3031 20.7524 28.4325 22.869 28.4325 25.4713C28.4325 28.0736 26.3031 30.1554 23.6851 30.1554C21.0671 30.1554 18.9377 28.0389 18.9377 25.4366C18.9377 22.8343 21.0671 20.7524 23.6851 20.7524Z",
    fill: "#00266B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_64_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 12,
    width: 6,
    height: 6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2805 12.807L29.1306 13.8826C29.2703 13.9867 29.3401 14.1601 29.2353 14.3336L27.3155 17.6646C27.2107 17.8034 27.0362 17.8728 26.8617 17.7687L25.0116 16.693C24.872 16.589 24.8021 16.4155 24.9069 16.242L26.8268 12.911C26.9315 12.7723 27.1409 12.7029 27.2805 12.807Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_64_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3751 12.7026H24.8372V17.8378H29.3751V12.7026Z",
    fill: "url(#paint2_linear_64_328)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_64_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 11,
    width: 6,
    height: 6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7611 11.9394L34.2621 13.2926C34.4017 13.4314 34.4366 13.6743 34.297 13.8478L31.7837 16.6236C31.644 16.7623 31.3997 16.797 31.2251 16.6583L29.7241 15.3051C29.5845 15.1663 29.5496 14.9234 29.6892 14.7499L32.2025 11.9741C32.3422 11.8353 32.5865 11.8006 32.7611 11.9394Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_64_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4366 11.8008H29.5496V16.7625H34.4366V11.8008Z",
    fill: "url(#paint3_linear_64_328)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_64_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 4,
    width: 6,
    height: 5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7119 4.02832H32.7611C32.9705 4.02832 33.1102 4.20181 33.1102 4.40999V8.43487C33.1102 8.64306 32.9356 8.81654 32.7262 8.81654H28.7119C28.5024 8.81654 28.3279 8.64306 28.3279 8.43487V4.40999C28.3628 4.20181 28.5024 4.02832 28.7119 4.02832Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_64_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1451 4.02832H28.3628V8.78185H33.1451V4.02832Z",
    fill: "url(#paint4_linear_64_328)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_64_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 7,
    width: 6,
    height: 6
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8307 8.67775L35.3091 7.67153C35.4836 7.60214 35.6931 7.67153 35.7629 7.87971L37.1242 11.2453C37.1941 11.4188 37.1242 11.627 36.9148 11.6964L34.4364 12.7026C34.2619 12.772 34.0524 12.7026 33.9826 12.4945L32.6212 9.12882C32.5514 8.95533 32.6561 8.78184 32.8307 8.67775Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_64_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1942 7.63672H32.5515V12.7719H37.1942V7.63672Z",
    fill: "url(#paint5_linear_64_328)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_328",
    x1: -15.107,
    y1: 13.0927,
    x2: 33.2354,
    y2: 76.0386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.196667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956667,
    stopColor: "#D39E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#D2D2D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_64_328",
    x1: 11.9837,
    y1: 27.5646,
    x2: 35.3652,
    y2: 27.5646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D53E0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF7E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_64_328",
    x1: 24.759,
    y1: 15.2814,
    x2: 29.4428,
    y2: 15.2815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3E63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_64_328",
    x1: 29.4178,
    y1: 14.2991,
    x2: 34.5362,
    y2: 14.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6210BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B2E71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_64_328",
    x1: 28.3438,
    y1: 6.39851,
    x2: 33.1169,
    y2: 6.39851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0A00C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_64_328",
    x1: 32.4969,
    y1: 10.2065,
    x2: 37.2518,
    y2: 10.2065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D5D59"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.1926,
    height: 38.2711,
    fill: "white",
    transform: "translate(10.0713 4.02832)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDalocal);
export default __webpack_public_path__ + "static/media/dalocal.5b7b03ac07017ddadc3fb6da7af072ee.svg";
export { ForwardRef as ReactComponent };